import { useTranslation } from '@/i18n';
import { ButtonV2 } from '@moneyforward/ap-frontend-components';
import classnames from 'classnames/bind';
import { memo } from 'react';
import styles from '../../index.module.scss';

const cx = classnames.bind(styles);

export const WithdrawalButton = memo(
  ({
    isDisabled,
    isLoading,
  }: {
    isDisabled?: boolean;
    isLoading?: boolean;
  }) => {
    const { t } = useTranslation();
    return (
      <div className={cx(styles['leave-button-container'])}>
        <ButtonV2
          color='danger'
          type='submit'
          isDisabled={isDisabled}
          isLoading={isLoading}
          size='md'
        >
          {t('office_withdrawal.leave')}
        </ButtonV2>
      </div>
    );
  }
);

WithdrawalButton.displayName = 'WithdrawalButton';
